module.exports = __webpack_public_path__ + "img/zizhi7.b8384d5c.jpg";